<template>
  <div class="detail-container">
    <Header />
    <div class="artcle-detail">
      <div class="container">
        <div class="left-detail">
          <div class="page">
            知识文章 > <span @click="$router.push('/artcle-page')" class="tap">{{typeTxt}}</span> > <span>{{detail.title}}</span>
          </div>
          <div v-html="detail.content">
          </div>
          <!-- <div class="title">
            什么是云服务器
            <span>2021-08-30</span>
          </div>
          <div class="txt">
            云服务器BCC（Baidu Cloud
            Compute）是处理能力可弹性伸缩的计算服务。管理方式比物理服务器更简单高效，可根据您的业务需要创建、释放任意多台云服务器实例，提升运维效率。为您快速部署应用构建稳定可靠的基础，降低网络规模计算的难度，使您更专注于核心业务创新。且无需花费时间和金钱来购买及维护托管虚拟机的硬件，有效降低IT成本。
          </div>
          <div class="bg">
            <img src="../../assets/home/report-null.png" alt="" />
          </div>
          <div class="two-headline">
            <div class="two-title">为什么选择云服务器</div>
            <ul>
              <li>1</li>
              <li>2</li>
            </ul>
          </div> -->
        </div>
        <hot-search :hotList="hotList" @getDetail="getDetail" />
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import { getArtcleDetail, getPopularArticles } from '@/api/artcle.js'
import Header from '@/components/Header/index.vue'
import HotSearch from './components/hot-search.vue'
import Footer from '@/components/Footer/index.vue'
export default {
  name: 'artcleDetail',
  components: {
    Header,
    HotSearch,
    Footer
  },
  props: {},
  data() {
    return {
      hotList: [],
      typeTxt: '',
      detail: {}
    }
  },
  computed: {},
  watch: {},
  created() {
    if (!this.$route.query.id) {
      this.$router.replace('/artcle-page')
    } else {
      if (this.$route.query.type == 1) {
        this.typeTxt = '最新文章'
      } else {
        this.typeTxt = '热门文章'
      }
      this.getPopularArticles()
      this.getArtcleDetail(this.$route.query.id)
    }
  },
  mounted() {

  },
  methods: {
    async getPopularArticles() {
      let res = await getPopularArticles()
      if (res.success) {
        this.hotList = res.data
      }
    },
    async getArtcleDetail(id) {
      let res = await getArtcleDetail(id)
      if (res.success) {
        this.detail = res.data
      }
    },
    getDetail(id) {
      this.getArtcleDetail(id)
    }
  }
}
</script>

<style scoped lang="scss">
.detail-container {
  position: relative;
  width: 100%;
  padding-top: 120px;
}
.artcle-detail {
  display: flex;
  justify-content: center;
  margin-bottom: 60px;
  .container {
    display: flex;
    justify-content: space-between;
    width: 1200px;
  }
  .left-detail {
    width: 880px;
    .page {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #24232f;
      margin-bottom: 42px;
      span {
        color: #3c7cff;
      }
      .tap {
        cursor: pointer;
        color: #24232f;
      }
    }
    .title {
      position: relative;
      font-size: 30px;
      font-weight: 500;
      color: #24232f;
      margin-bottom: 20px;
      span {
        position: absolute;
        bottom: -5px;
        right: 0;
        font-size: 12px;
        font-weight: 400;
        color: #767d8f;
      }
    }
    .txt {
      font-size: 14px;
      font-weight: 400;
      color: #767d8f;
      line-height: 28px;
      margin-bottom: 32px;
    }
    .bg {
      margin-bottom: 28px;
      img {
        width: 880px;
        height: 420px;
      }
    }
    .two-headline {
      font-size: 14px;
      .two-title {
        font-weight: 700;
        color: #24232f;
        margin-bottom: 12px;
      }
      ul {
        padding-left: 18px;
        font-weight: 400;
        color: #767d8f;
        line-height: 28px;
      }
    }
  }
}
</style>
